export interface DarkColors {
    neutral_400: string;
    mainGreen: string;
    primary_050: string;
    primary_100: string;
    primary_200: string;
    primary_300: string;
    primary_400: string;
    primary_500: string;
    primary_600: string;
    primary_700: string;
    primary_800: string;
    gray_100: string;
    gray_200: string;
    gray_300: string;
    gray_400: string;
    gray_500: string;
    gray_600: string;
    gray_700: string;
    gray_800: string;
    secondary_000: string;
    secondary_100: string;
    secondary_200: string;
    secondary_300: string;
    secondary_400: string;
    secondary_500: string;
    secondary_600: string;
    tertiary_blueGrey: string;
    tertiary_blueMedium: string;
    tertiary_blueSky: string;
    tertiary_blueTurqoise: string;
    tertiary_turqoiseSoft: string;
    tertiary_brown: string;
    tertiary_ocher: string;
    tertiary_orange: string;
    tertiary_yellow: string;
    tertiary_purple: string;
    tertiary_fuchsia: string;
    tertiary_pink: string;
    tertiary_greenSoft: string;
    tertiary_blueSoft: string;
    tertiary_pinkSoft: string;
    tertiary_yellowSoft: string;
    error_01: string;
    error_03: string;
    error_02: string;
    error_04: string;
    error_05: string;
    success_05: string;
    success_04: string;
    success_03: string;
    success_02: string;
    success_01: string;
    warning_05: string;
    warning_04: string;
    warning_03: string;
    warning_02: string;
    warning_01: string;
    warning_00: string;
    white: string;
    black: string;
    successBar: string;
    background:string;
    primaryText:string;
    secondaryBackground:string;
    hr:string;
    navbarBorder:string;
    navBackground:string;
  }

  export const colors: DarkColors = {
    neutral_400: '#CED4DA',
    mainGreen: '#99CC33',
    primary_050: '#ECF6D1',
    primary_100: '#D9EEA8',
    primary_200: '#BFE274',
    primary_300: '#99CC33',
    primary_400: '#789F26',
    primary_500: '#58721A',
    primary_600: '#3D5C00',
    primary_700: '#37450D',
    primary_800: '#161800',
    gray_100: '#FFFFFF',
    gray_200: '#3A3B3C',
    gray_300: '#E8E9EB',
    gray_400: '#C2C8CD',
    gray_500: '#929CA3',
    gray_600: '#61707A',
    gray_700: '#314450',
    gray_800: '#001827',
    secondary_000: '#BAD2FF',
    secondary_100: '#78A8FF',
    secondary_200: '#3C86E3',
    secondary_300: '#0063C6',
    secondary_400: '#004A8F',
    secondary_500: '#003159',
    secondary_600: '#BAD2FF',
    tertiary_blueGrey: '#5D82A6',
    tertiary_blueMedium: '#4F8AC6',
    tertiary_blueSky: '#34A7E0',
    tertiary_blueTurqoise: '#00A7A7',
    tertiary_turqoiseSoft: '#3CDBC0',
    tertiary_brown: '#B3582D',
    tertiary_ocher: '#C68C2F',
    tertiary_orange: '#F7912B',
    tertiary_yellow: '#FAB623',
    tertiary_purple: '#6C387F',
    tertiary_fuchsia: '#9F1A77',
    tertiary_pink: '#D81E5D',
    tertiary_greenSoft: '#E9F2D3',
    tertiary_blueSoft: '#D7EDFA',
    tertiary_pinkSoft: '#F7D1DE',
    tertiary_yellowSoft: '#FEF0D3',
    error_01: '#FFA9B1',
    error_03: '#C9264D',
    error_02: '#E4687F',
    error_04: '#97193B',
    error_05: '#660D29',
    success_05: '#044927',
    success_04: '#097645',
    success_03: '#0DA362',
    success_02: '#11D07F',
    success_01: '#8DFFE0',
    warning_05: '#544209',
    warning_04: '#887112',
    warning_03: '#BBA01B',
    warning_02: '#EFCF24',
    warning_01: '#FFF87C',
    warning_00: '#FDFAC4',
    white: '#FFFFFF',
    black: '#000000',
    successBar:'#CDFBEE',
    background:'#242526',
    navBackground:'#99CC33',
    secondaryBackground:'#E4E6EB',
    primaryText:'#E8E9EB',
    hr:'#c6c8c8',
    navbarBorder:'#99CC33'
  };
